module.exports = __webpack_public_path__ + "img/eclectic.b7590012.jpg";